import * as React from "react";

const PlayArrow: React.FC = () => <svg>Play Arrow</svg>;

export default PlayArrow;
